module.exports = __webpack_public_path__ + "static/media/points_icon.81c210dc.svg";